import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { WorkflowStatusAction } from "../../utilities/interfaces/WorkflowStatusAction";
import { workflowStatusActionApi } from "../../utilities/api/workflowStatusActionApi";
import { roleApi } from "../../utilities/api/roleApi";
import { workflowStatusActionRoleApi } from "../../utilities/api/workflowStatusActionRoleApi";

interface workflowStatusActionState {
  statusActions: WorkflowStatusAction[];
  statusAction: WorkflowStatusAction | null;
  fetchingStatusActions: boolean;
}

const initialState: workflowStatusActionState = {
  statusActions: [],
  statusAction: null,
  fetchingStatusActions: false,
}

const workflowStatusActionSlice = createSlice({
  name: 'stateWorkflowStatusAction',
  initialState,
  reducers: {
    clearStatusActions(state) {
      state.statusActions = [];
    }
  },
  extraReducers(builder) {
    builder.addCase(getWorkflowStatusActionById.fulfilled, (state, action: any) => {
      state.statusAction = action.payload;
      state.fetchingStatusActions = false;
    });
    builder.addCase(getWorkflowStatusActionsByStatusId.fulfilled, (state, action: any) => {
      state.statusActions = action.payload;
      state.fetchingStatusActions = false;
    });
    builder.addCase(getWorkflowStatusActionsByStatusAndRoleIds.fulfilled, (state, action: any) => {
      state.statusActions = action.payload;
      state.fetchingStatusActions = false;
    });
    builder.addCase(getWorkflowStatusActionById.pending, (state) => {
      state.fetchingStatusActions = true;
    });
    builder.addCase(getWorkflowStatusActionsByStatusId.pending, (state) => {
      state.fetchingStatusActions = true;
    });
    builder.addCase(getWorkflowStatusActionsByStatusAndRoleIds.pending, (state) => {
      state.fetchingStatusActions = true;
    });
    builder.addCase(getWorkflowStatusActionById.rejected, (state) => {
      state.fetchingStatusActions = false;
    });
    builder.addCase(getWorkflowStatusActionsByStatusId.rejected, (state) => {
      state.fetchingStatusActions = false;
    });
    builder.addCase(getWorkflowStatusActionsByStatusAndRoleIds.rejected, (state) => {
      state.fetchingStatusActions = false;
    });
  }
});

export const getWorkflowStatusActionById = createAsyncThunk('stateWorkflowStatusAction/getWorkflowStatusActionById', async (id: number) => {
  const response = await workflowStatusActionApi.getById(id);
  return response;
});

export const getWorkflowStatusActionsByStatusId = createAsyncThunk('stateWorkflowStatusAction/getWorkflowStatusActionByStatusId', async (id: number) => {
  const response = await workflowStatusActionApi.getByStatusId(id);
  return response;
});

export const getWorkflowStatusActionsByStatusAndRoleIds = createAsyncThunk('stateWorkflowStatusAction/getWorkflowStatusActionsByStatusAndRoleIds', async (statusId: number) => {
  // get status actions
  const statusActions: any[] = await workflowStatusActionApi.getByStatusId(statusId) ?? [];

  // get roles
  const roleNames: any[] = JSON.parse(sessionStorage.getItem('roles') ?? "[]");

  // get status action roles by role name
  let statusActionRoles: any[] = [];
  for (let roleName of roleNames) {
    let newActionRoles = await workflowStatusActionRoleApi.getByRoleName(roleName);
    statusActionRoles = statusActionRoles.concat(newActionRoles);
  }

  // filter out status actions not listed in status action roles
  const filteredStatusActions = statusActions.filter(sa => statusActionRoles.findIndex(sar => sar.id === sa.id) !== -1);

  return filteredStatusActions;
});

export const { clearStatusActions } = workflowStatusActionSlice.actions;
export default workflowStatusActionSlice.reducer;